export const awsServices = [
  {
    slug: "aws-reselling",
    icon: "BadgePercent",
    popular: true,
    calculator: true,
    es: {
      name: "AWS Reselling",
      tagline: "3% de descuento directo en toda tu factura AWS durante los primeros 12 meses.",
      intro: "Como AWS Partner autorizado, compramos capacidad cloud en volumen y te trasladamos el descuento. Tú sigues usando AWS exactamente igual — simplemente pagas menos.",
      blocks: [
        {
          h: "Cómo funciona",
          p: "Trasladamos tu facturación a nuestra cuenta de partner. No hay migración, no hay downtime, no hay cambios técnicos. Solo un cambio administrativo que se traduce en ahorro inmediato.",
          list: ["Onboarding en menos de 1 semana", "Sin compromiso de permanencia", "Acceso completo a tu consola AWS, como siempre"],
        },
        {
          h: "Más que un descuento",
          p: "El reselling incluye acompañamiento experto continuo: revisiones de arquitectura, asesoría FinOps y negociación de créditos AWS que por tu cuenta no conseguirías.",
          list: ["Revisiones anuales de arquitectura gratuitas", "Acceso a programas de créditos AWS", "Soporte técnico ampliado"],
        },
        {
          h: "Para quién es",
          p: "Startups y scaleups que gastan entre 500$ y 100.000$ mensuales en AWS y quieren dejar de pagar de más sin complejidad.",
          list: ["Startups en crecimiento", "Empresas con gasto cloud estable", "Equipos sin FinOps interno"],
        },
        {
          h: "Facturación AWS simplificada",
          p: "Olvídate de pagar AWS con tarjeta. Sustituye los cargos en tarjeta por una única factura mensual, con condiciones de pago adaptadas a tu empresa. Tu infraestructura sigue igual. Tu facturación se simplifica.",
          list: ["Una única factura mensual", "Pago mediante transferencia bancaria", "Facilita la gestión contable y la conciliación", "Mayor control y visibilidad del gasto", "Sin cambios en tu infraestructura AWS"],
        },
      ],
      outcomes: ["3% de descuento inmediato + 10–30% por optimización", "50–90% de descuento en tarifas CloudFront", "Créditos AWS negociados para ti", "Cero cambios en tu infraestructura"],
    },
    en: {
      name: "AWS Reselling",
      tagline: "3% direct discount on your entire AWS bill for the first 12 months.",
      intro: "As an authorized AWS Partner, we buy cloud capacity in volume and pass the discount on to you. You keep using AWS exactly the same — you simply pay less.",
      blocks: [
        {
          h: "How it works",
          p: "We move your billing to our partner account. No migration, no downtime, no technical changes. Just an administrative switch that translates into immediate savings.",
          list: ["Onboarding in under 1 week", "No lock-in commitment", "Full access to your AWS console, as always"],
        },
        {
          h: "More than a discount",
          p: "Reselling includes continuous expert guidance: architecture reviews, FinOps advisory and AWS credits negotiation you couldn't get on your own.",
          list: ["Free annual architecture reviews", "Access to AWS credit programs", "Extended technical support"],
        },
        {
          h: "Who it's for",
          p: "Startups and scaleups spending between $500 and $100,000 a month on AWS who want to stop overpaying without complexity.",
          list: ["Growing startups", "Companies with stable cloud spend", "Teams without in-house FinOps"],
        },
        {
          h: "Simplified AWS billing",
          p: "Forget paying AWS by card. Replace card charges with a single monthly invoice, with payment terms adapted to your company. Your infrastructure stays the same. Your billing gets simpler.",
          list: ["One single monthly invoice", "Payment via bank transfer", "Easier accounting and reconciliation", "Greater control and spend visibility", "No changes to your AWS infrastructure"],
        },
      ],
      outcomes: ["3% immediate discount + 10–30% from optimization", "50–90% off CloudFront rates", "AWS credits negotiated for you", "Zero infrastructure changes"],
    },
  },
  {
    slug: "aws-cost-optimization",
    icon: "TrendingDown",
    es: {
      name: "AWS Cost Optimization",
      tagline: "Reduce tus costes AWS. De forma continua.",
      intro: "Optimiza tu infraestructura, elimina gasto innecesario y aprovecha mejor los modelos de ahorro de AWS. Combinamos tecnología, automatización y expertise AWS para mantener tus costes alineados con el uso real. Menos desperdicio. Más control. Más valor de AWS.",
      blocks: [
        {
          h: "Auditoría profunda",
          p: "Analizamos cada línea de tu factura: instancias infrautilizadas, almacenamiento huérfano, transferencias de datos invisibles y servicios olvidados.",
          list: ["Rightsizing de instancias EC2 y RDS", "Limpieza de volúmenes y snapshots huérfanos", "Análisis de transferencia de datos"],
        },
        {
          h: "Estrategia de compromiso",
          p: "Diseñamos tu mix óptimo de Savings Plans, Reserved Instances y Spot para tu patrón de consumo real — no para el teórico.",
          list: ["Savings Plans & Reserved Instances", "Estrategia Spot para cargas tolerantes", "Cobertura vs. flexibilidad equilibradas"],
        },
        {
          h: "Optimización continua",
          p: "La optimización no es un proyecto puntual: implantamos dashboards, alertas y procesos para que el ahorro se mantenga en el tiempo.",
          list: ["Dashboards de coste en tiempo real", "Alertas de anomalías de gasto", "Cultura de eficiencia para tus equipos"],
        },
      ],
      outcomes: ["25–35% de reducción media del gasto", "Visibilidad total del coste por equipo/producto", "Procesos de optimización implantados", "ROI desde el primer mes"],
    },
    en: {
      name: "AWS Cost Optimization",
      tagline: "Reduce your AWS costs. Continuously.",
      intro: "Optimize your infrastructure, eliminate unnecessary spend and make the most of AWS savings models. We combine technology, automation and AWS expertise to keep your costs aligned with real usage. Less waste. More control. More value from AWS.",
      blocks: [
        {
          h: "Deep audit",
          p: "We analyze every line of your bill: underutilized instances, orphaned storage, invisible data transfers and forgotten services.",
          list: ["EC2 and RDS rightsizing", "Orphaned volumes & snapshots cleanup", "Data transfer analysis"],
        },
        {
          h: "Commitment strategy",
          p: "We design your optimal mix of Savings Plans, Reserved Instances and Spot for your real consumption pattern — not the theoretical one.",
          list: ["Savings Plans & Reserved Instances", "Spot strategy for tolerant workloads", "Balanced coverage vs. flexibility"],
        },
        {
          h: "Continuous optimization",
          p: "Optimization isn't a one-off project: we implement dashboards, alerts and processes so savings stick over time.",
          list: ["Real-time cost dashboards", "Spend anomaly alerts", "Efficiency culture for your teams"],
        },
      ],
      outcomes: ["25–35% average spend reduction", "Full cost visibility per team/product", "Optimization processes in place", "ROI from month one"],
    },
  },
  {
    slug: "aws-migration",
    icon: "Rocket",
    es: {
      name: "Migration to AWS",
      tagline: "Migraciones cloud sin dolor: lift-and-shift, re-platforming y refactoring.",
      intro: "Migrar no es mover máquinas: es transformar cómo opera tu empresa. Diseñamos y ejecutamos migraciones con cero sorpresas y mínimo downtime.",
      blocks: [
        {
          h: "Assessment & plan",
          p: "Auditamos tu infraestructura actual, dependencias y riesgos. Definimos la estrategia de las 6R para cada carga: rehost, replatform, refactor, repurchase, retain o retire.",
          list: ["Discovery completo de aplicaciones", "Business case y TCO cloud", "Roadmap por fases con hitos claros"],
        },
        {
          h: "Ejecución controlada",
          p: "Migramos por oleadas con rollback plan en cada paso. Tu negocio sigue funcionando mientras nosotros movemos los cimientos.",
          list: ["Migración por oleadas sin downtime", "Validación y testing en cada fase", "Cutover planificado fuera de horas críticas"],
        },
        {
          h: "Modernización de tu capa de datos",
          p: "Una vez en AWS, modernizamos lo que de verdad importa: tus datos. Bases de datos gestionadas, pipelines de datos y almacenamiento analítico listo para BI y ML.",
          list: ["Bases de datos gestionadas (Aurora, RDS, DynamoDB)", "Pipelines de datos cloud-native", "Data warehouse y analítica con Redshift"],
        },
      ],
      outcomes: ["Migración sin interrupción de negocio", "Capa de datos modernizada y lista para analítica", "Arquitectura lista para escalar", "Equipo formado en la nueva plataforma"],
    },
    en: {
      name: "Migration to AWS",
      tagline: "Painless cloud migration: lift-and-shift, re-platforming and refactoring.",
      intro: "Migrating isn't moving machines: it's transforming how your company operates. We design and execute migrations with zero surprises and minimal downtime.",
      blocks: [
        {
          h: "Assessment & plan",
          p: "We audit your current infrastructure, dependencies and risks. We define the 6R strategy for each workload: rehost, replatform, refactor, repurchase, retain or retire.",
          list: ["Full application discovery", "Cloud business case and TCO", "Phased roadmap with clear milestones"],
        },
        {
          h: "Controlled execution",
          p: "We migrate in waves with a rollback plan at every step. Your business keeps running while we move the foundations.",
          list: ["Zero-downtime wave migration", "Validation and testing at each phase", "Cutover planned outside critical hours"],
        },
        {
          h: "Data layer modernization",
          p: "Once on AWS, we modernize what truly matters: your data. Managed databases, data pipelines and analytical storage ready for BI and ML.",
          list: ["Managed databases (Aurora, RDS, DynamoDB)", "Cloud-native data pipelines", "Data warehousing & analytics with Redshift"],
        },
      ],
      outcomes: ["Migration without business disruption", "Modernized data layer, ready for analytics", "Architecture ready to scale", "Team trained on the new platform"],
    },
    deep: {
      es: {
        kicker: "Metodología de migración",
        title: "De tu infraestructura actual a AWS, sin sobresaltos",
        intro: "Una migración bien hecha no se nota: tu equipo trabaja el lunes como si nada, pero sobre una plataforma que escala. Este es nuestro método.",
        caps: [
          { t: "Descubrimiento total", d: "Inventario de aplicaciones, dependencias y riesgos antes de tocar nada. Sin sorpresas a mitad de camino." },
          { t: "Estrategia 6R", d: "Cada carga tiene su camino: rehost, replatform, refactor, repurchase, retain o retire. Nada de mover por mover." },
          { t: "Datos primero", d: "La capa de datos se moderniza en el viaje: Aurora, DynamoDB y Redshift listos para analítica." },
          { t: "Cero downtime", d: "Oleadas con rollback en cada paso y cutover fuera de horas críticas. El negocio nunca se detiene." },
        ],
        visual: {
          label: "La ruta, semana a semana",
          phases: [
            { t: "Assessment & business case", w: "Semanas 1–2", d: "Discovery completo, TCO y roadmap por fases con hitos claros." },
            { t: "Migración por oleadas", w: "Semanas 3–6", d: "Bloques de cargas migradas con validación y rollback en cada paso." },
            { t: "Modernización de datos", w: "Semanas 7–9", d: "Bases de datos gestionadas, pipelines cloud-native y almacenamiento analítico." },
            { t: "Operación y mejora", w: "Semana 10+", d: "Monitorización, costes bajo control y tu equipo formado en la nueva plataforma." },
          ],
        },
        steps: [
          { n: "01", t: "Descubrimos", d: "Auditamos aplicaciones, dependencias y datos para saber exactamente qué hay." },
          { n: "02", t: "Planificamos", d: "Business case con TCO, ahorro esperado y estrategia 6R por carga." },
          { n: "03", t: "Migramos", d: "Por oleadas, con testing y plan de rollback en cada fase." },
          { n: "04", t: "Modernizamos", d: "Tu capa de datos pasa a servicios gestionados listos para BI y ML." },
          { n: "05", t: "Operamos", d: "Dejamos monitorización, alertas y un equipo que entiende su nueva nube." },
        ],
        closing: { title: "El lunes siguiente, todo igual. La plataforma, otra.", body: "Migraciones sin interrupción del negocio y con la capa de datos lista para analítica desde el primer día.", cta: "Planifica mi migración" },
      },
      en: {
        kicker: "Migration methodology",
        title: "From your current infrastructure to AWS, without surprises",
        intro: "A well-run migration goes unnoticed: your team works on Monday as usual, but on a platform that scales. This is our method.",
        caps: [
          { t: "Full discovery", d: "Inventory of applications, dependencies and risks before touching anything. No surprises halfway." },
          { t: "6R strategy", d: "Every workload gets its path: rehost, replatform, refactor, repurchase, retain or retire. No moving for moving's sake." },
          { t: "Data first", d: "The data layer gets modernized on the journey: Aurora, DynamoDB and Redshift ready for analytics." },
          { t: "Zero downtime", d: "Waves with rollback at every step and cutover outside critical hours. Business never stops." },
        ],
        visual: {
          label: "The route, week by week",
          phases: [
            { t: "Assessment & business case", w: "Weeks 1–2", d: "Full discovery, TCO and a phased roadmap with clear milestones." },
            { t: "Wave migration", w: "Weeks 3–6", d: "Workload blocks migrated with validation and rollback at every step." },
            { t: "Data modernization", w: "Weeks 7–9", d: "Managed databases, cloud-native pipelines and analytical storage." },
            { t: "Operate & improve", w: "Week 10+", d: "Monitoring, costs under control and your team trained on the new platform." },
          ],
        },
        steps: [
          { n: "01", t: "We discover", d: "We audit applications, dependencies and data to know exactly what's there." },
          { n: "02", t: "We plan", d: "Business case with TCO, expected savings and a 6R strategy per workload." },
          { n: "03", t: "We migrate", d: "In waves, with testing and a rollback plan at each phase." },
          { n: "04", t: "We modernize", d: "Your data layer moves to managed services ready for BI and ML." },
          { n: "05", t: "We operate", d: "We leave monitoring, alerts and a team that understands its new cloud." },
        ],
        closing: { title: "Next Monday, same as ever. The platform, transformed.", body: "Migrations without business disruption and with the data layer ready for analytics from day one.", cta: "Plan my migration" },
      },
    },
  },
  {
    slug: "aws-well-architected",
    icon: "Layers",
    es: {
      name: "AWS Well-Architected Review",
      tagline: "Auditoría completa de tu arquitectura en los 6 pilares del framework de AWS.",
      intro: "El Well-Architected Framework es el estándar de AWS para construir bien en la nube. Como partners certificados, revisamos tu arquitectura y te entregamos un plan de remediación accionable.",
      blocks: [
        {
          h: "Los 6 pilares",
          p: "Evaluamos tu arquitectura en cada dimensión del framework: excelencia operativa, seguridad, fiabilidad, eficiencia de rendimiento, optimización de costes y sostenibilidad.",
          list: ["Operational Excellence", "Security & Reliability", "Performance, Cost & Sustainability"],
        },
        {
          h: "Informe accionable",
          p: "No entregamos un PDF que se queda en un cajón: cada hallazgo viene con prioridad, impacto estimado y plan de remediación concreto.",
          list: ["Hallazgos clasificados por riesgo (HRIs)", "Plan de remediación priorizado", "Estimación de esfuerzo e impacto"],
        },
        {
          h: "Remediación con créditos",
          p: "AWS financia parte de la remediación de riesgos altos a través de créditos de servicio. Nosotros gestionamos todo el proceso.",
          list: ["Gestión de créditos AWS para remediación", "Ejecución del plan por nuestro equipo", "Re-review de validación"],
        },
      ],
      outcomes: ["Arquitectura alineada con best practices de AWS", "Riesgos críticos identificados y remediados", "Créditos AWS para la remediación", "Confianza para escalar"],
    },
    en: {
      name: "AWS Well-Architected Review",
      tagline: "Full audit of your architecture across the 6 pillars of the AWS framework.",
      intro: "The Well-Architected Framework is AWS's standard for building well in the cloud. As certified partners, we review your architecture and deliver an actionable remediation plan.",
      blocks: [
        {
          h: "The 6 pillars",
          p: "We evaluate your architecture across every dimension of the framework: operational excellence, security, reliability, performance efficiency, cost optimization and sustainability.",
          list: ["Operational Excellence", "Security & Reliability", "Performance, Cost & Sustainability"],
        },
        {
          h: "Actionable report",
          p: "We don't deliver a PDF that sits in a drawer: every finding comes with priority, estimated impact and a concrete remediation plan.",
          list: ["Findings classified by risk (HRIs)", "Prioritized remediation plan", "Effort and impact estimates"],
        },
        {
          h: "Credit-backed remediation",
          p: "AWS funds part of high-risk remediation through service credits. We manage the entire process.",
          list: ["AWS remediation credits management", "Plan execution by our team", "Validation re-review"],
        },
      ],
      outcomes: ["Architecture aligned with AWS best practices", "Critical risks identified and remediated", "AWS credits for remediation", "Confidence to scale"],
    },
    deep: {
      es: {
        kicker: "Framework Well-Architected",
        title: "Seis pilares. Una foto honesta de tu arquitectura.",
        intro: "La review oficial mide tu arquitectura contra el estándar de quien construyó la nube. Sales con un plan de remediación priorizado — y con créditos AWS para ejecutarlo.",
        caps: [
          { t: "Review oficial", d: "Con las herramientas y el cuestionario del framework de AWS, codo a codo con tu equipo." },
          { t: "Riesgos primero", d: "Los hallazgos de alto riesgo (HRI) van delante: lo que puede romperse, se arregla primero." },
          { t: "Créditos AWS", d: "Gestionamos los créditos de servicio que AWS ofrece para remediar riesgos altos." },
          { t: "Re-review incluida", d: "Validamos que cada riesgo quedó cerrado. Sin cabos sueltos." },
        ],
        visual: {
          label: "Puntuación objetivo por pilar tras la remediación",
          pillars: [
            { n: "Excelencia operativa", v: 88 },
            { n: "Seguridad", v: 94 },
            { n: "Fiabilidad", v: 90 },
            { n: "Eficiencia de rendimiento", v: 86 },
            { n: "Optimización de costes", v: 92 },
            { n: "Sostenibilidad", v: 80 },
          ],
          note: "Objetivo típico tras ejecutar el plan de remediación con nuestro equipo.",
        },
        steps: [
          { n: "01", t: "Review conjunta", d: "Sesión de trabajo con tu equipo y el cuestionario oficial del framework." },
          { n: "02", t: "Hallazgos por riesgo", d: "Cada hallazgo clasificado por riesgo, impacto estimado y esfuerzo." },
          { n: "03", t: "Plan de remediación", d: "Priorizado y accionable: qué hacer, en qué orden y por qué." },
          { n: "04", t: "Remediación con créditos", d: "AWS financia parte de la remediación de riesgos altos. Nosotros la ejecutamos." },
          { n: "05", t: "Re-review", d: "Validamos la remediación y dejamos el ciclo de mejora funcionando." },
        ],
        closing: { title: "Construido como lo construiría AWS.", body: "Arquitectura alineada con las mejores prácticas del framework, riesgos críticos cerrados y confianza para escalar.", cta: "Solicita tu review" },
      },
      en: {
        kicker: "Well-Architected Framework",
        title: "Six pillars. An honest picture of your architecture.",
        intro: "The official review measures your architecture against the standard of those who built the cloud. You leave with a prioritized remediation plan — and AWS credits to execute it.",
        caps: [
          { t: "Official review", d: "Using the AWS framework's own tools and questionnaire, side by side with your team." },
          { t: "Risks first", d: "High-risk findings (HRIs) come first: what can break gets fixed first." },
          { t: "AWS credits", d: "We manage the service credits AWS offers to remediate high risks." },
          { t: "Re-review included", d: "We validate that every risk was actually closed. No loose ends." },
        ],
        visual: {
          label: "Target score per pillar after remediation",
          pillars: [
            { n: "Operational Excellence", v: 88 },
            { n: "Security", v: 94 },
            { n: "Reliability", v: 90 },
            { n: "Performance Efficiency", v: 86 },
            { n: "Cost Optimization", v: 92 },
            { n: "Sustainability", v: 80 },
          ],
          note: "Typical target after executing the remediation plan with our team.",
        },
        steps: [
          { n: "01", t: "Joint review", d: "Working session with your team and the framework's official questionnaire." },
          { n: "02", t: "Findings by risk", d: "Every finding classified by risk, estimated impact and effort." },
          { n: "03", t: "Remediation plan", d: "Prioritized and actionable: what to do, in what order and why." },
          { n: "04", t: "Credit-backed remediation", d: "AWS funds part of high-risk remediation. We execute it." },
          { n: "05", t: "Re-review", d: "We validate the remediation and leave the improvement cycle running." },
        ],
        closing: { title: "Built the way AWS would build it.", body: "Architecture aligned with framework best practices, critical risks closed and confidence to scale.", cta: "Request your review" },
      },
    },
  },
  {
    slug: "aws-security",
    icon: "ShieldCheck",
    es: {
      name: "AWS Security",
      tagline: "IAM zero-trust, guardrails, detección automatizada de amenazas y compliance.",
      intro: "La seguridad cloud no es un producto que se compra: es una disciplina que se practica. Diseñamos, implantamos y monitorizamos tu postura de seguridad en AWS.",
      blocks: [
        {
          h: "Identidad & acceso",
          p: "Revisamos y endurecemos tu modelo IAM hacia zero-trust: mínimo privilegio, MFA everywhere, roles temporales y separación de entornos.",
          list: ["Auditoría IAM & least privilege", "AWS Organizations & SCPs", "SSO centralizado con IAM Identity Center"],
        },
        {
          h: "Detección & respuesta",
          p: "Desplegamos la red de detección nativa de AWS: GuardDuty, Security Hub, Config y CloudTrail, con playbooks de respuesta ante incidentes.",
          list: ["GuardDuty & Security Hub", "Alertas centralizadas y triaje", "Playbooks de respuesta a incidentes"],
        },
        {
          h: "Compliance & gobierno del dato",
          p: "Te preparamos para auditorías y marcos regulatorios (ISO 27001, SOC 2, RGPD) y te ayudamos a gobernar tu activo más crítico: el dato.",
          list: ["RGPD / GDPR y protección de datos", "ISO 27001 & SOC 2 readiness", "Gobierno, catalogación y calidad del dato"],
        },
      ],
      outcomes: ["Postura de seguridad zero-trust", "Detección de amenazas 24/7", "Auditorías sin sustos", "Datos cifrados y bajo control"],
    },
    en: {
      name: "AWS Security",
      tagline: "Zero-trust IAM, guardrails, automated threat detection and compliance.",
      intro: "Cloud security isn't a product you buy: it's a discipline you practice. We design, implement and monitor your security posture on AWS.",
      blocks: [
        {
          h: "Identity & access",
          p: "We review and harden your IAM model towards zero-trust: least privilege, MFA everywhere, temporary roles and environment separation.",
          list: ["IAM audit & least privilege", "AWS Organizations & SCPs", "Centralized SSO with IAM Identity Center"],
        },
        {
          h: "Detection & response",
          p: "We deploy AWS's native detection network: GuardDuty, Security Hub, Config and CloudTrail, with incident response playbooks.",
          list: ["GuardDuty & Security Hub", "Centralized alerts and triage", "Incident response playbooks"],
        },
        {
          h: "Compliance & data governance",
          p: "We prepare you for audits and regulatory frameworks (ISO 27001, SOC 2, GDPR) and help you govern your most critical asset: data.",
          list: ["GDPR & data protection", "ISO 27001 & SOC 2 readiness", "Data governance, cataloging & quality"],
        },
      ],
      outcomes: ["Zero-trust security posture", "24/7 threat detection", "Audits without surprises", "Encrypted, controlled data"],
    },
    deep: {
      es: {
        kicker: "Postura de seguridad",
        title: "Seguridad que se practica todos los días",
        intro: "No es un producto que se instala y se olvida: es una disciplina. Diseñamos, implantamos y monitorizamos tu postura de seguridad en AWS — de la identidad al dato.",
        caps: [
          { t: "Identidad zero-trust", d: "IAM endurecido: mínimo privilegio, MFA en todas partes y roles temporales." },
          { t: "Detección nativa", d: "GuardDuty, Security Hub, Config y CloudTrail desplegados y afinados." },
          { t: "Compliance real", d: "RGPD, ISO 27001 y SOC 2 con evidencias listas para auditoría." },
          { t: "Gobierno del dato", d: "Tu activo más crítico, catalogado, cifrado y con calidad medida." },
        ],
        visual: {
          label: "Controles que dejamos activos",
          controls: ["IAM least privilege y MFA", "GuardDuty + Security Hub", "CloudTrail y Config en todas las regiones", "Cifrado en reposo y en tránsito", "Guardrails con AWS Organizations", "Playbooks de respuesta a incidentes"],
          stat: "24/7",
          statLabel: "Detección de amenazas continua",
        },
        steps: [
          { n: "01", t: "Assessment", d: "Medimos tu postura actual: identidad, red, datos y logging." },
          { n: "02", t: "Endurecimiento", d: "IAM zero-trust, guardrails y separación de entornos." },
          { n: "03", t: "Detección", d: "La red de detección nativa de AWS, desplegada y con triaje." },
          { n: "04", t: "Compliance", d: "Evidencias y controles listos para tu próxima auditoría." },
          { n: "05", t: "Vigilancia", d: "Alertas, playbooks y revisión continua de la postura." },
        ],
        closing: { title: "Duerme tranquilo: tu nube está vigilada.", body: "Postura zero-trust, detección 24/7 y datos cifrados y gobernados.", cta: "Audita mi seguridad" },
      },
      en: {
        kicker: "Security posture",
        title: "Security that's practiced every day",
        intro: "It's not a product you install and forget: it's a discipline. We design, implement and monitor your security posture on AWS — from identity to data.",
        caps: [
          { t: "Zero-trust identity", d: "Hardened IAM: least privilege, MFA everywhere and temporary roles." },
          { t: "Native detection", d: "GuardDuty, Security Hub, Config and CloudTrail deployed and tuned." },
          { t: "Real compliance", d: "GDPR, ISO 27001 and SOC 2 with audit-ready evidence." },
          { t: "Data governance", d: "Your most critical asset: cataloged, encrypted and quality-measured." },
        ],
        visual: {
          label: "Controls we leave active",
          controls: ["Least-privilege IAM and MFA", "GuardDuty + Security Hub", "CloudTrail and Config in all regions", "Encryption at rest and in transit", "Guardrails with AWS Organizations", "Incident response playbooks"],
          stat: "24/7",
          statLabel: "Continuous threat detection",
        },
        steps: [
          { n: "01", t: "Assessment", d: "We measure your current posture: identity, network, data and logging." },
          { n: "02", t: "Hardening", d: "Zero-trust IAM, guardrails and environment separation." },
          { n: "03", t: "Detection", d: "AWS's native detection network, deployed and triaged." },
          { n: "04", t: "Compliance", d: "Evidence and controls ready for your next audit." },
          { n: "05", t: "Vigilance", d: "Alerts, playbooks and continuous posture review." },
        ],
        closing: { title: "Sleep tight: your cloud is being watched.", body: "Zero-trust posture, 24/7 detection and encrypted, governed data.", cta: "Audit my security" },
      },
    },
  },
  {
    slug: "databases-data-models",
    icon: "Database",
    es: {
      name: "Databases & Data Models",
      tagline: "Relacional, NoSQL, Redshift y Aurora: diseño y optimización de tu capa de datos.",
      intro: "La base de datos es donde vive tu negocio. Diseñamos modelos de datos y arquitecturas de bases de datos que aguantan tu crecimiento sin despeñarse.",
      blocks: [
        {
          h: "Diseño de modelos",
          p: "Modelado relacional y dimensional hecho para durar: esquemas normalizados donde toca, desnormalizados donde rinde, y pensados para analítica desde el origen.",
          list: ["Modelado relacional & dimensional", "Data vault & star schemas", "Diseño orientado a analítica", "Calidad y gobierno del dato"],
        },
        {
          h: "El motor correcto",
          p: "No todo es Postgres (aunque nos encante). Elegimos contigo el motor adecuado para cada caso: Aurora, RDS, DynamoDB, Redshift, ElastiCache.",
          list: ["Aurora & RDS para cargas transaccionales", "DynamoDB para escala extrema", "Redshift para analítica a gran escala"],
        },
        {
          h: "Rendimiento & coste",
          p: "Optimizamos queries, índices y configuraciones para que tus bases de datos vuelen sin que la factura despegue.",
          list: ["Query tuning & indexación", "Read replicas & caching", "Aurora Serverless para cargas variables"],
        },
      ],
      outcomes: ["Modelos de datos preparados para escalar", "Motor adecuado para cada carga", "Queries hasta 100x más rápidas", "Coste de base de datos bajo control"],
    },
    en: {
      name: "Databases & Data Models",
      tagline: "Relational, NoSQL, Redshift and Aurora: design and optimization of your data layer.",
      intro: "The database is where your business lives. We design data models and database architectures that handle your growth without falling apart.",
      blocks: [
        {
          h: "Model design",
          p: "Relational and dimensional modeling built to last: normalized where it belongs, denormalized where it performs, and designed for analytics from the start.",
          list: ["Relational & dimensional modeling", "Data vault & star schemas", "Analytics-oriented design", "Data quality & governance"],
        },
        {
          h: "The right engine",
          p: "Not everything is Postgres (much as we love it). We choose the right engine for each case with you: Aurora, RDS, DynamoDB, Redshift, ElastiCache.",
          list: ["Aurora & RDS for transactional loads", "DynamoDB for extreme scale", "Redshift for large-scale analytics"],
        },
        {
          h: "Performance & cost",
          p: "We optimize queries, indexes and configurations so your databases fly without the bill taking off.",
          list: ["Query tuning & indexing", "Read replicas & caching", "Aurora Serverless for variable loads"],
        },
      ],
      outcomes: ["Data models ready to scale", "Right engine for each workload", "Queries up to 100x faster", "Database cost under control"],
    },
    deep: {
      es: {
        kicker: "Ingeniería de la capa de datos",
        title: "Bases de datos que aguantan tu crecimiento",
        intro: "La mayoría de los problemas de rendimiento nacen en el modelo, no en el motor. Diseñamos modelos de datos y arquitecturas que escalan sin que la factura despegue.",
        caps: [
          { t: "Modelado que dura", d: "Relacional y dimensional pensado para analítica desde el origen: star schemas y data vault." },
          { t: "El motor correcto", d: "Aurora, RDS, DynamoDB, Redshift o ElastiCache — según la carga, no la moda." },
          { t: "Rendimiento & coste", d: "Query tuning, índices, réplicas y caching para volar sin pagar de más." },
          { t: "Calidad & gobierno", d: "Catálogo, linaje y reglas de calidad para que el dato sea de fiar." },
        ],
        visual: {
          label: "Antes / después en proyectos de optimización",
          legendBefore: "Antes",
          legendAfter: "Después",
          metrics: [
            { label: "Query crítica de reporting", before: "850 ms", after: "12 ms", beforePct: 100, afterPct: 8 },
            { label: "Coste mensual de base de datos", before: "4.200 €", after: "1.900 €", beforePct: 100, afterPct: 45 },
            { label: "Tiempo para levantar un entorno", before: "2 semanas", after: "20 min", beforePct: 100, afterPct: 4 },
          ],
          note: "Ejemplos representativos de proyectos de optimización de la capa de datos.",
        },
        steps: [
          { n: "01", t: "Auditamos", d: "Modelos, queries lentas, índices y coste actual de cada base." },
          { n: "02", t: "Diseñamos", d: "El modelo objetivo y el motor adecuado para cada carga." },
          { n: "03", t: "Optimizamos", d: "Migración, tuning y caching con medición antes y después." },
          { n: "04", t: "Gobernamos", d: "Catálogo, calidad y linaje para que el dato aguante." },
          { n: "05", t: "Evolucionamos", d: "Revisión continua a medida que crece tu negocio." },
        ],
        closing: { title: "El dato bien modelado es media batalla ganada.", body: "Modelos preparados para escalar, queries hasta 100x más rápidas y coste bajo control.", cta: "Optimiza mis datos" },
      },
      en: {
        kicker: "Data layer engineering",
        title: "Databases that keep up with your growth",
        intro: "Most performance problems are born in the model, not the engine. We design data models and architectures that scale without the bill taking off.",
        caps: [
          { t: "Modeling that lasts", d: "Relational and dimensional modeling designed for analytics from the start: star schemas and data vault." },
          { t: "The right engine", d: "Aurora, RDS, DynamoDB, Redshift or ElastiCache — chosen by workload, not fashion." },
          { t: "Performance & cost", d: "Query tuning, indexes, replicas and caching to fly without overpaying." },
          { t: "Quality & governance", d: "Catalog, lineage and quality rules so your data can be trusted." },
        ],
        visual: {
          label: "Before / after in optimization projects",
          legendBefore: "Before",
          legendAfter: "After",
          metrics: [
            { label: "Critical reporting query", before: "850 ms", after: "12 ms", beforePct: 100, afterPct: 8 },
            { label: "Monthly database cost", before: "€4,200", after: "€1,900", beforePct: 100, afterPct: 45 },
            { label: "Time to spin up an environment", before: "2 weeks", after: "20 min", beforePct: 100, afterPct: 4 },
          ],
          note: "Representative examples from data layer optimization projects.",
        },
        steps: [
          { n: "01", t: "We audit", d: "Models, slow queries, indexes and the current cost of every database." },
          { n: "02", t: "We design", d: "The target model and the right engine for each workload." },
          { n: "03", t: "We optimize", d: "Migration, tuning and caching with before-and-after measurement." },
          { n: "04", t: "We govern", d: "Catalog, quality and lineage so the data holds up." },
          { n: "05", t: "We evolve", d: "Continuous review as your business grows." },
        ],
        closing: { title: "Well-modeled data is half the battle won.", body: "Models ready to scale, queries up to 100x faster and costs under control.", cta: "Optimize my data" },
      },
    },
  },
];
